const KEY = "TODOITEMSANDBOX";

export function saveTodo(todo) {
  window.localStorage.setItem(KEY, JSON.stringify(todo));
}

export function getTodo() {
  return JSON.parse(window.localStorage.getItem(KEY));
}
